import React, { FC } from 'react';
import { Box } from '@scope/scope-one-ui/core';
import { Skeleton } from '@mui/material';
import { SIZES } from '@scope/scope-one-ui/theme';

export const ChartLoader: FC = () => (
  <>
    <Box display="flex" gridGap={2} m={2}>
      <Skeleton width="10%" height={SIZES.spacing(5)} />
      <Skeleton width="10%" height={SIZES.spacing(5)} />
      <Skeleton width="10%" height={SIZES.spacing(5)} />
      <Skeleton width="10%" height={SIZES.spacing(5)} />
    </Box>
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      style={{ height: SIZES.spacing(40) }}
    >
      <Skeleton width="90%" height="30%" />
    </Box>
  </>
);
